<template>
  <v-checkbox
    ref="atinput"
    :disabled="disabled"
    v-model="bvalue"
    @change="changed"
    :true-value="true"
    :false-value="false"
    :label="label"
    color="primary"
  ></v-checkbox>
  <!--
  <span>
    <v-checkbox
      ref="atinput"
      :disabled="disabled"
      v-model="bvalue"
      @change="changed"
      :true-value="true"
      :false-value="false"
      :label="label"
      v-if="editing"
      color="primary"
    ></v-checkbox>
    <v-icon v-else medium color="primary">{{ this.bvalue ? 'check' : 'close' }}</v-icon>
  </span>
  -->
</template>

<script>
import ATInputMixin from "./ATInputMixin.js";

export default {
  mixins: [ATInputMixin],
  data() {
    return {
      bvalue: this.text
    };
  },
  watch: {
    text() {
      this.bvalue = this.text;
    }
  }
};
</script>

<style>
</style>